import {SearchCategoryThumbnails} from "models/SearchState"
import breakpointToViewportSize from "../breakpointToViewportSize"
import env from "../../config/env"

export const getSearchCategoryThumbnail = (
    searchCategoryThumbnailsConfig: SearchCategoryThumbnails[] = [],
    searchCategoryId: string,
    filterName: string,
    facetName: string,
    currentBreakpoint: string,
) => {
    const searchCategory = searchCategoryThumbnailsConfig.find(
        category => category.searchCategoryId === searchCategoryId,
    )

    const clientType = breakpointToViewportSize(currentBreakpoint) === "desktop" ? "Desktop" : "Apps"
    if (searchCategory) {
        const filterConfig = searchCategory.filters.find(filter => filter.name === filterName)
        let {imagePath} = searchCategory
        if (filterConfig) {
            const size = filterConfig.thumbnailSizes.find(thumbnail => thumbnail.clientType === clientType)
            if (size) {
                imagePath = imagePath.replace("{searchcategoryId}", searchCategoryId)
                imagePath = imagePath.replace("{filtername}", filterName)
                imagePath = imagePath.replace("{size}", size.size)
                imagePath = imagePath.replace("{filtervalue}", facetName)
                return {
                    imagePath: `${env.REACT_APP_CDN_BASEURL.replace(
                        "content",
                        "searchcategorythumbnails",
                    )}${imagePath}`,
                    size: size.size,
                }
            }
            return null
        }
    }
    return null
}
